import { Lesson } from "@jelly/lesson";

import principle01 from "./layouts/principle-01/principle";
import principle02 from "./layouts/principle-02/principle";
import task01 from "./layouts/task-01/task";
import task02 from "./layouts/task-02/task";

const lesson: Lesson = {
  id: "eda58ade-7bd8-4f7c-8f8a-ba7f53dfa506",
  publicId: "19",
  name: "Real-time convolution",
  difficulty: 3,
  contentTypes: { audio: false, interactive: false, video: true },
  body: [principle01, principle02, task01, task02],
};

export default lesson;
